<footer *ngIf="!flagAreaPrivada" [ngClass]="getPath() ? 'margin-bottom' : ''">
  <section class="side-margin">
    <div class="footer no-print">
      <div class="footer--wrapper">
        <div class="columns">
          <a routerLink="/"
            ><img
              src="{{ picturesServer }}img/home/inviertis-icon-yellow.svg"
              alt="Ícono Inviertis"
              loading="lazy"
          /></a>
          <div class="socials">
            <a
              rel="nofollow"
              href="https://twitter.com/inviertis"
              target="_blank"
              ><img
                src="{{ picturesServer }}img/home/icono-twitter.svg"
                alt="Ícono twitter"
                loading="lazy"
            /></a>
            <a
              rel="nofollow"
              href="https://www.facebook.com/Inviertis"
              target="_blank"
              ><img
                src="{{ picturesServer }}img/home/icono-facebook.svg"
                alt="Ícono facebook"
                loading="lazy"
            /></a>
            <a
              rel="nofollow"
              href="https://www.linkedin.com/company/10941867/"
              target="_blank"
              ><img
                src="{{ picturesServer }}img/home/icono-linkedin.svg"
                alt="Ícono linkedin"
                loading="lazy"
            /></a>
            <a
              rel="nofollow"
              href="https://www.instagram.com/inviertis"
              target="_blank"
              ><img
                src="{{ picturesServer }}img/home/icono-insta.svg"
                alt="Ícono instagram"
                loading="lazy"
            /></a>
          </div>
        </div>
        <div class="columns">
          <h3 class="footer--title">{{ 'components.footer.Invierte' | translate }}</h3>
          <ul class="footer--list">
            <li class="footer--item">
              <a (click)="goNavigateToUrl('invertir')"
                >{{ 'components.footer.Buscar inmuebles' | translate }}</a
              >
            </li>
            <li class="footer--item">
              <a (click)="openCallModal()"
                >{{ 'components.footer.Habla con un experto' | translate }}</a
              >
            </li>
            <li class="footer--item">
              <a (click)="goNavigateToUrl('como-funciona/consulting')"
                >{{ 'components.footer.¿Cómo funciona Invertir con Inviertis?' | translate }}</a
              >
            </li>
          </ul>
        </div>
        <div class="columns">
          <h3 class="footer--title">{{ 'components.footer.Vender' | translate }}</h3>
          <ul class="footer--list">
            <li class="footer--item">
              <a rel="alternate" (click)="goNavigateToUrl('vende')"
                >{{ 'components.footer.Vende tu piso alquilado' | translate }}</a
              >
            </li>
            <!-- <li class="footer--item">
              <a
                rel="alternate"
                (click)="goNavigateToUrl('calculadora-de-rentabilidad')"
                >{{ 'components.footer.¿Cuánto vale mi piso alquilado?' | translate }}</a
              >
            </li> -->
            <li class="footer--item">
              <a rel="alternate" (click)="openCallModal()"
                >{{ 'components.footer.Infórmate gratis' | translate }}</a
              >
            </li>
          </ul>
        </div>
        <div class="columns">
          <h3 class="footer--title">
            {{ 'components.footer.Sobre Inviertis' | translate }}
          </h3>
          <ul class="footer--list">
            <li class="footer--item">
              <a
                rel="alternate"
                (click)="goNavigateToUrl('sobre-nosotros')"
                >{{ 'components.footer.Sobre Nosotros' | translate }}</a
              >
            </li>
            <li class="footer--item">
              <a href="https://blog.inviertispro.com" target="_blank"
                >{{ 'components.footer.Blog para inversionistas' | translate }}</a
              >
            </li>
            <li class="footer--item">
              <a
                rel="alternate"
                (click)="goNavigateToUrl('como-funciona/services')"
                >{{ 'components.footer.Servicios' | translate }}</a
              >
            </li>
          </ul>
        </div>
        <div class="columns">
          <h3 class="footer--title">{{ 'components.footer.Contacto' | translate }}</h3>
          <ul class="footer--list">
            <li class="footer--item">
              <a rel="nofollow" href="tel:+34919497969">
                <img
                  class="icon-btn"
                  src="{{ picturesServer }}img/home/icono-telefono-outline.svg"
                  alt="Ícono teléfono"
                  loading="lazy"
                />
                (+34) 919 49 79 69
              </a>
            </li>
            <li class="footer--item">
              <a rel="nofollow" href="mailto:info@inviertispro.com"
                ><img
                  class="icon-btn"
                  src="{{ picturesServer }}img/home/icono-at-outline.svg"
                  alt="Ícono"
                  loading="lazy"
                />
                info&#64;inviertispro.com</a
              >
            </li>
          </ul>
        </div>
        <div class="columns columns-btn">
          <div class="btn btn-yellow" (click)="openSignInModal()">
            <img
              class="icon-btn"
              src="{{ picturesServer }}img/home/icono-usuario.svg"
              alt="Ícono usuario"
              loading="lazy"
            />
            <span class="text-btn"
              >{{ 'components.footer.Crear cuenta' | translate }}</span
            >
          </div>
          <button
            class="btn btn-white"
            id="btn-callmeback-header"
            (click)="openCallModal()"
          >
            <img
              class="icon-btn"
              src="{{ picturesServer }}img/home/icono-telefono.svg"
              alt="Ícono teléfono"
              loading="lazy"
            />
            {{ 'components.footer.Te llamamos' | translate }}
          </button>
        </div>
      </div>

      <div class="links-container">
        <div class="links">
          <span>2025 © Inviertis Properties SL.</span>
          <span
            >{{ 'components.footer.Todos los derechos reservados.' | translate }}</span
          >
          <a
            (click)="goNavigateToUrl('aviso-legal')"
            style="text-decoration: underline"
            >{{ 'components.footer.Aviso Legal' | translate }}</a
          >
          <a
            (click)="goNavigateToUrl('politica-de-privacidad')"
            style="text-decoration: underline"
            >{{ 'components.footer.Política de Privacidad' | translate }}</a
          >
          <a
            (click)="goNavigateToUrl('politica-de-cookies')"
            style="text-decoration: underline"
            >Cookies</a
          >
          <span> v{{ versionado }} </span>
        </div>
        <div class="language-selector">
          <app-i18n></app-i18n>
        </div>
      </div>
    </div>
  </section>
</footer>
